import _ from 'lodash';

import trainTime from '../lib/TrainTime';

export const smartCarnetSchema = SmartCarnetSearch => {
    if (!SmartCarnetSearch) {
        return null;
    }

    const stationFromName = _.get(SmartCarnetSearch, 'origin.name');
    const stationFromNLC = _.get(SmartCarnetSearch, 'origin.nlc');
    const stationFromCRS = _.get(SmartCarnetSearch, 'origin.crs');
    const stationDestinationName = _.get(SmartCarnetSearch, 'destination.name');
    const stationDestinationNLC = _.get(SmartCarnetSearch, 'destination.nlc');
    const stationDestinationCRS = _.get(SmartCarnetSearch, 'destination.crs');
    const rawFromDateTime =
        SmartCarnetSearch.startingDate && SmartCarnetSearch.startingDate.format('YYYY-MM-DD');

    const fromDateTime = SmartCarnetSearch.startingDate.isBefore(trainTime())
        ? trainTime().format('YYYY-MM-DD')
        : rawFromDateTime;

    if (
        !stationFromName ||
        (!stationFromNLC && !stationFromCRS) ||
        !stationDestinationName ||
        (!stationDestinationNLC && !stationDestinationCRS) ||
        !rawFromDateTime
    ) {
        return null;
    }

    return {
        smartCarnet: {
            stationFrom: {
                name: stationFromName,
                nlc: stationFromNLC,
                crs: stationFromCRS,
            },
            stationTo: {
                name: stationDestinationName,
                nlc: stationDestinationNLC,
                crs: stationDestinationCRS,
            },
            fromDateTime,
        },
    };
};

export const daySaveSchema = DaySaveSearch => {
    if (!DaySaveSearch) {
        return null;
    }

    const stationFromName = _.get(DaySaveSearch, 'origin.name');
    const stationFromNLC = _.get(DaySaveSearch, 'origin.nlc');
    const stationFromCRS = _.get(DaySaveSearch, 'origin.crs');
    const fromDateTime = DaySaveSearch.date && DaySaveSearch.date.format('YYYY-MM-DD');
    const adults = _.get(DaySaveSearch, 'adults');
    const children = _.get(DaySaveSearch, 'children');

    if (!stationFromName || (!stationFromNLC && !stationFromCRS) || !fromDateTime) {
        return null;
    }

    return {
        daySave: {
            stationFrom: {
                name: stationFromName,
                nlc: stationFromNLC,
                crs: stationFromCRS,
            },
            fromDateTime,
            adults,
            children,
        },
    };
};

export const roversRangersSchema = RoversRangers => {
    if (!RoversRangers) {
        return null;
    }

    const roverType = _.get(RoversRangers, 'ticketType.code');
    const fromDateTime = RoversRangers.date && RoversRangers.date.format('YYYY-MM-DD');
    const adults = _.get(RoversRangers, 'adults');
    const children = _.get(RoversRangers, 'children');
    const railcards =
        RoversRangers.railcards &&
        RoversRangers.railcards.size > 0 &&
        RoversRangers.railcards.toJS().map((railcard, index) => {
            return {
                id: index,
                quantity: railcard.quantity,
                railcardCode: railcard.code,
            };
        });

    if (!roverType || !fromDateTime) {
        return null;
    }

    return {
        rovers: {
            roverType: roverType,
            fromDateTime,
            adults,
            children,
            railcards,
        },
    };
};



// WEBPACK FOOTER //
// ./src/helpers/JPWidgetSchemas.js